/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { QuantityUsageType } from './QuantityUsageType';
import {
    instanceOfQuantityUsageType,
    QuantityUsageTypeFromJSON,
    QuantityUsageTypeFromJSONTyped,
    QuantityUsageTypeToJSON,
} from './QuantityUsageType';

/**
 * @type EnumerationQuantityDtoQuantityUsageType
 * 
 * @export
 */
export type EnumerationQuantityDtoQuantityUsageType = QuantityUsageType;


export function EnumerationQuantityDtoQuantityUsageTypeFromJSON(json: any): EnumerationQuantityDtoQuantityUsageType {
    return EnumerationQuantityDtoQuantityUsageTypeFromJSONTyped(json, false);
}

export function EnumerationQuantityDtoQuantityUsageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationQuantityDtoQuantityUsageType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...QuantityUsageTypeFromJSONTyped(json, true) };
    return  QuantityUsageTypeFromJSONTyped(json, true);
}

export function EnumerationQuantityDtoQuantityUsageTypeToJSON(value?: EnumerationQuantityDtoQuantityUsageType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfQuantityUsageType(value)) {
        return QuantityUsageTypeToJSON(value as QuantityUsageType);
    }

    return {};
}

/**
 * Check if a given object implements the EnumerationQuantityDtoQuantityUsageType interface.
 */
export function instanceOfEnumerationQuantityDtoQuantityUsageType(value: any): value is EnumerationQuantityDtoQuantityUsageType {
    if (instanceOfQuantityUsageType(value)) return true;
    return false;
}

